import styled from "styled-components";
import { DefaultCellHeader } from "./DefaultCellHeader";

export const DefaultCellHeaderRightAlign = styled(DefaultCellHeader)<{
    reverseDirection?: boolean;
}>`
    flex-direction: row-reverse;
    display: flex;
    width: 100%;
    .u-flex-row {
        flex-direction: ${({ reverseDirection = true }) => (reverseDirection ? "row-reverse" : "row")};
        max-width: 100%;
    }
    .headerCell-sortDirection {
        margin-left: 0;
    }
`;
DefaultCellHeaderRightAlign.displayName = "DefaultCellHeaderRightAlign";
